module.exports = __webpack_public_path__ + "img/glossary.0e72416e.svg";